import { useLocation, useNavigate } from 'react-router'

import { Store } from './types'
import { useDirectFlowStore } from './useDirectFlowStore'
import { usePostQuoteEditStore } from './usePostQuoteEditStore'

import { useEventTracking } from 'utils'

type Type = 'directFlow' | 'postQuoteEdit'

const storeMapping: Record<Type, Store> = {
  directFlow: useDirectFlowStore,
  postQuoteEdit: usePostQuoteEditStore,
}

type ExternalStoreAPI = (params: { quoteId: string; type: Type }) => ReturnType<Store>

export const useExternalStore: ExternalStoreAPI = ({ quoteId, type }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const track = useEventTracking()

  const useStore = storeMapping[type]
  const store = useStore(quoteId, { navigate, location, track })

  return store
}
